'use client';

// Error components must be Client Components
import { block as _block$ } from "million/react-server";
import { useEffect } from 'react';
const M$Error = function Error({
  error,
  reset
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error(error);
  }, [error]);
  return <div>
      <h2>Something went wrong!</h2>
      <button onClick={
    // Attempt to recover by trying to re-render the segment
    () => reset()}>
        Try again
      </button>
    </div>;
};
const Error = M$Error;
export default Error;